import { actionTypes } from '../actions/constants';

const defaultState = {
    isDrawerOpen: true,
};

export function drawerReducer(state = defaultState, action) {
    switch (action.type) {
        case actionTypes.SET_DRAWER_STATE: {
            const { isDrawerOpen } = action.payload;
            return { isDrawerOpen };
        }
        default:
            return state;
    }
}
